import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';

interface BettieUnfinishedChatRoomCardProps {
  balance: number;
}

const BettieUnfinishedChatRoomCard = ({ balance }: BettieUnfinishedChatRoomCardProps) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() =>
        navigate('/bettie-setting', {
          state: { initialStep: 'room_intro' }
        })
      }
      className="w-full rounded-[20px] bg-pure-white px-[18px] py-[8px] text-left shadow-[0_0_3px_rgba(0,0,0,0.02),_0_0_13px_rgba(0,0,0,0.03)] dark:bg-background-elevated"
    >
      <div className="flex items-center justify-between border-b border-surface-lv1 py-[10px]">
        <p className="text-[12px] font-medium leading-[14px] text-text-main-lv4">
          {t('BettieChatList.unfinishedChatRoom')}
        </p>
        {balance > 1 && (
          <span className="rounded-[42px] bg-surface-lv2 px-[6px] py-[2px] text-[11px] font-semibold leading-[13px] text-text-main-lv3">
            + {balance - 1}
          </span>
        )}
      </div>
      <div className="flex items-center gap-[10px] py-[12px]">
        <img
          src="/assets/bettie/bettie_empty_profile.png"
          alt=""
          className="size-[48px] shrink-0 rounded-full object-cover"
        />
        <div className="flex min-w-0 flex-1 items-center justify-between">
          <div className="flex min-w-0 flex-col items-start gap-[4px]">
            <p className="text-[15px] font-semibold leading-[18px] text-text-main-lv2">
              {t('BettieChatList.settingChatRoom')}
            </p>
            <p className="text-[13px] leading-[16px] text-text-main-lv3">
              {t('BettieChatList.startConversation')}
            </p>
          </div>
        </div>
      </div>
    </button>
  );
};

export default BettieUnfinishedChatRoomCard;
